import styled from "styled-components";

interface ContentProps {
  noMaxWidth?: boolean;
  padding?: string;
}

export const ContainerBodyWebCheckin = styled.div<{ padding?: string }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: ${props => props.padding || "20px"};
  background: url(/assets/ETP04-001-A.svg);
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  overflow: auto;
  font-family: "Manrope"  !important;
  color: 'red' !important;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: ${props => props.padding || "20px"};
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  flex: 1;
  ${props => !props.noMaxWidth && "max-width: 464px;"}
`;
